import { Box } from "@mui/material";
import React from "react";
import { QuotationFormValues } from "../../../types";
import {
  QUOTATION_BOX_DIMENSIONS_FIELDS,
  QUOTATION_SECTION_KEYS,
} from "../data";
import {
  renderFieldControls,
} from "../VehicleDetails/FormControls";
import QuotationInputCard from "./QuotationInputCard";
import { useStyles } from "./styles";

type Props = {
  formValues: QuotationFormValues;
  updateField: (field: keyof QuotationFormValues, value: string | boolean) => void;
};

const BoxDimensionsPanel = ({ formValues, updateField }: Props) => {
  const styles = useStyles();

  return (
    <QuotationInputCard titleKey={QUOTATION_SECTION_KEYS.BOX_DIMENSIONS}>
      <Box className={styles.grid2}>
        {renderFieldControls(
          QUOTATION_BOX_DIMENSIONS_FIELDS,
          formValues,
          updateField
        )}
      </Box>
    </QuotationInputCard>
  );
};

export default BoxDimensionsPanel;
